﻿document.addEventListener('DOMContentLoaded', () => {
    // --- Configuration ---
    const CHECKOUT_BTN_SELECTOR = 'cart-drawer .cart__checkout-button';

    async function refreshCartDrawerAfterUpgrade() {
        const cartUrl = window.routes?.cart_url || '/cart';
        const response = await fetch(`${cartUrl}?section_id=cart-drawer`, {
            credentials: 'same-origin',
            cache: 'no-store',
        });
        if (!response.ok) return;

        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const sourceDrawer = doc.querySelector('cart-drawer');
        const targetDrawer = document.querySelector('cart-drawer');

        if (sourceDrawer && targetDrawer) {
            const wasOpen =
                targetDrawer.classList.contains('active') ||
                targetDrawer.hasAttribute('open');
            const sourceInner = sourceDrawer.querySelector('.drawer__inner');
            const targetInner = targetDrawer.querySelector('.drawer__inner');

            if (sourceInner && targetInner) {
                targetInner.replaceWith(sourceInner);
            }

            targetDrawer.classList.toggle('is-empty', sourceDrawer.classList.contains('is-empty'));
            if (wasOpen) {
                targetDrawer.classList.add('active');
                targetDrawer.setAttribute('open', '');
            }
        } else {
            ['cart-drawer-items', '.drawer__footer', '.cart-progress', '.cart-checkpoints-bar'].forEach(
                (selector) => {
                    const source = doc.querySelector(selector);
                    const target =
                        document.querySelector(`cart-drawer ${selector}`) ||
                        document.querySelector(selector);
                    if (source && target) target.replaceWith(source);
                }
            );
        }

        const bubble = document.querySelector('#cart-icon-bubble .cart-count-bubble span[aria-hidden="true"]');
        const cartRes = await fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' });
        if (cartRes.ok) {
            const cart = await cartRes.json();
            window.__cartHasSubscription = cart.items.some(
                (item) => item.selling_plan_allocation != null
            );
            if (bubble) bubble.textContent = String(cart.item_count);

            const bubbleWrapper = document.querySelector('#cart-icon-bubble .cart-count-bubble');
            if (bubbleWrapper) {
                bubbleWrapper.classList.toggle('hidden', cart.item_count === 0);
                if (cart.item_count === 0) bubbleWrapper.setAttribute('hidden', '');
                else bubbleWrapper.removeAttribute('hidden');
            }
        }

        if (window.SofyreCartUpsells?.syncCartState) {
            await window.SofyreCartUpsells.syncCartState();
        }
    }

    function getShippingProtectionVariantIds() {
        const ids = new Set();
        document
            .querySelectorAll(
                'cart-drawer [data-shipping-protection-default="true"][data-id], cart-drawer .shipping-protection-product[data-id]'
            )
            .forEach((el) => {
                const id = Number(el.dataset.id);
                if (id) ids.add(id);
            });
        ids.add(50801410736446);
        return ids;
    }

    function isShippingProtectionCartItem(item) {
        if (!item) return false;

        const title = `${item.product_title || ''} ${item.title || ''}`.toLowerCase();
        const handle = `${item.handle || item.product_handle || ''}`.toLowerCase();

        if (title.includes('shipping protection')) return true;
        if (handle.includes('liver-wellness-pack-wrap-castor-oil')) return true;
        if (getShippingProtectionVariantIds().has(Number(item.variant_id))) return true;

        return false;
    }

    function cartHasMainItems(cart) {
        return (cart?.items || []).some((item) => !isShippingProtectionCartItem(item));
    }

    async function clearCartIfOnlyShippingProtection(cart) {
        if (!cart?.items?.length) return cart;
        if (cartHasMainItems(cart)) return cart;

        const clearRes = await fetch('/cart/clear.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { Accept: 'application/json' },
        });
        if (clearRes.ok) {
            return clearRes.json();
        }

        for (const item of cart.items) {
            await fetch('/cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                credentials: 'same-origin',
                body: JSON.stringify({ id: item.key, quantity: 0 }),
            });
        }
        const cartRes = await fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' });
        return cartRes.ok ? cartRes.json() : cart;
    }

    function clearCartDrawerErrors() {
        document
            .querySelectorAll(
                '#CartDrawer-CartErrors, cart-drawer .cart-item__error, cart-drawer .cart-item__error-text'
            )
            .forEach((el) => {
                if (el.id === 'CartDrawer-CartErrors') {
                    el.textContent = '';
                    el.classList.add('hidden');
                } else if (el.classList.contains('cart-item__error-text')) {
                    el.textContent = '';
                } else {
                    el.classList.remove('is-visible');
                    const text = el.querySelector('.cart-item__error-text');
                    if (text) text.textContent = '';
                }
            });
    }

    function setCartLineLoading(lineItem, loading) {
        if (!lineItem) return;

        lineItem.classList.toggle('loading', loading);
        lineItem.classList.toggle('cart-drawer-item--removing', loading);

        const overlay = lineItem.querySelector('.loading-overlay');
        if (overlay) {
            overlay.classList.toggle('hidden', !loading);
        }

        const drawerItems = document.querySelector('cart-drawer cart-drawer-items');
        if (drawerItems) {
            if (loading) {
                drawerItems.classList.add('is-loading');
                drawerItems.setAttribute('aria-busy', 'true');
            } else {
                drawerItems.classList.remove('is-loading');
                drawerItems.removeAttribute('aria-busy');
            }
        }

        lineItem.querySelectorAll('.quantity__button, .quantity__input, cart-remove-button button').forEach((el) => {
            el.disabled = loading;
        });
    }

    async function changeCartLineQuantity(lineItem, quantity) {
        if (!lineItem) return;

        const lineKey = lineItem.getAttribute('data-item-key');
        const lineIndex =
            lineItem.querySelector('.quantity__input')?.getAttribute('data-index') ||
            lineItem.getAttribute('data-index') ||
            '';

        if (!lineKey && !lineIndex) return;

        const isRemove = quantity <= 0;
        setCartLineLoading(lineItem, true);
        clearCartDrawerErrors();

        try {
            const payload = lineKey
                ? { id: lineKey, quantity: isRemove ? 0 : quantity }
                : { line: Number(lineIndex), quantity: isRemove ? 0 : quantity };

            const response = await fetch('/cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                credentials: 'same-origin',
                body: JSON.stringify(payload),
            });

            if (!response.ok) {
                throw new Error(await response.text());
            }

            let cart = await response.json();
            if (isRemove) {
                cart = await clearCartIfOnlyShippingProtection(cart);
            }

            await refreshCartDrawerAfterUpgrade();
            clearCartDrawerErrors();
        } catch (error) {
            console.error('Cart line quantity change failed:', error);
            setCartLineLoading(lineItem, false);
            const input = lineItem.querySelector('.quantity__input');
            if (input) input.value = input.getAttribute('data-cart-quantity') || '1';
        }
    }

    async function removeCartLineItem(lineItem) {
        await changeCartLineQuantity(lineItem, 0);
    }

    function isCartLineBusy(lineItem) {
        return (
            lineItem.classList.contains('loading') ||
            lineItem.classList.contains('cart-drawer-item--removing')
        );
    }

    function stopCartDrawerEvent(event) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
    }

    // Capture phase: trash/remove button (live theme disables minus at qty 1)
    document.body.addEventListener(
        'click',
        (event) => {
            const removeControl = event.target.closest('cart-drawer cart-remove-button');
            if (!removeControl) return;

            const lineItem = removeControl.closest('.cart-drawer-item, [data-item-key]');
            if (!lineItem || lineItem.classList.contains('shipping-product')) return;
            if (isCartLineBusy(lineItem)) {
                stopCartDrawerEvent(event);
                return;
            }

            stopCartDrawerEvent(event);
            removeCartLineItem(lineItem);
        },
        true
    );

    // Capture phase: qty 1 + minus => remove line (before theme QuantityInput stepDown)
    document.body.addEventListener(
        'click',
        (event) => {
            const minusBtn = event.target.closest(
                'cart-drawer .quantity__button--minus, cart-drawer .quantity__button[name="minus"]'
            );
            if (!minusBtn || minusBtn.classList.contains('disabled') || minusBtn.disabled) return;

            const quantityInput = minusBtn.closest('quantity-input')?.querySelector('.quantity__input');
            const currentQty = Number(quantityInput?.value || 0);
            if (currentQty > 1) return;

            stopCartDrawerEvent(event);
            removeCartLineItem(minusBtn.closest('.cart-drawer-item, [data-item-key]'));
        },
        true
    );

    function commitCartDrawerQuantity(input, event) {
        if (!input || input.dataset.sofyreQtyCommitting === 'true') return;

        const rawValue = String(input.value).trim();
        const qty = rawValue === '' ? 0 : Number(rawValue);
        if (!Number.isFinite(qty) || qty < 0) return;

        const lineItem = input.closest('.cart-drawer-item, [data-item-key]');
        if (!lineItem || lineItem.classList.contains('shipping-product')) return;
        if (isCartLineBusy(lineItem)) {
            if (event) stopCartDrawerEvent(event);
            return;
        }

        if (event) stopCartDrawerEvent(event);

        input.dataset.sofyreQtyCommitting = 'true';
        if (qty === 0) input.value = '0';

        Promise.resolve(changeCartLineQuantity(lineItem, qty)).finally(() => {
            delete input.dataset.sofyreQtyCommitting;
        });
    }

    // All quantity input changes: use line key instead of theme line index
    document.body.addEventListener(
        'change',
        (event) => {
            const input = event.target.closest('cart-drawer .quantity__input');
            if (!input) return;
            commitCartDrawerQuantity(input, event);
        },
        true
    );

    // min=1 inputs often skip change when set to 0; blur/enter still commit removal
    document.body.addEventListener(
        'blur',
        (event) => {
            const input = event.target.closest('cart-drawer .quantity__input');
            if (!input) return;
            const qty = Number(input.value);
            if (!Number.isFinite(qty) || qty > 0) return;
            commitCartDrawerQuantity(input, event);
        },
        true
    );

    document.body.addEventListener(
        'keydown',
        (event) => {
            if (event.key !== 'Enter') return;
            const input = event.target.closest('cart-drawer .quantity__input');
            if (!input) return;
            commitCartDrawerQuantity(input, event);
        },
        true
    );

    async function addCheckoutPopupUpsell(button) {
        const variantId = button.getAttribute('data-product-id');
        if (!variantId) {
            throw new Error('Checkout popup upsell variant ID missing');
        }

        const sellingPlanId = button.getAttribute('data-selling-id') || '';
        let hasSubscription = false;

        try {
            const cartRes = await fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' });
            const cart = await cartRes.json();
            hasSubscription = cart.items.some((item) => item.selling_plan_allocation != null);

            const existingLine = cart.items.find((item) => String(item.variant_id) === String(variantId));
            if (existingLine && existingLine.quantity >= 1) {
                return;
            }
        } catch (error) {
            console.warn('Unable to read cart before checkout popup upsell add:', error);
        }

        const basePayload = {
            id: Number(variantId),
            quantity: 1,
            properties: {
                _sofyre_checkout_popup: 'true',
            },
        };

        const payloads = [];
        if (hasSubscription && sellingPlanId) {
            payloads.push({ ...basePayload, selling_plan: Number(sellingPlanId) });
        }
        payloads.push({ ...basePayload });

        let lastError = null;

        for (const itemPayload of payloads) {
            try {
                const response = await fetch('/cart/add.js?kaching_popup=true', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        Accept: 'application/json',
                    },
                    credentials: 'same-origin',
                    body: JSON.stringify({ items: [itemPayload] }),
                });

                if (!response.ok) {
                    const text = await response.text();
                    lastError = new Error(text || '400 Bad Request');
                    continue;
                }

                const cartAfterAdd = await fetch('/cart.js', {
                    credentials: 'same-origin',
                    cache: 'no-store',
                }).then((res) => res.json());
                const upsellLine = cartAfterAdd.items.find(
                    (item) => String(item.variant_id) === String(variantId)
                );

                if (!upsellLine) {
                    lastError = new Error('Checkout popup upsell missing from cart after add');
                    continue;
                }

                if (upsellLine.quantity > 1) {
                    await fetch('/cart/change.js', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            Accept: 'application/json',
                        },
                        credentials: 'same-origin',
                        body: JSON.stringify({
                            id: upsellLine.key,
                            quantity: 1,
                        }),
                    });
                }

                return;
            } catch (error) {
                lastError = error;
            }
        }

        throw lastError || new Error('Failed to add checkout popup upsell');
    }

    function isKachingSubscriptionSelected() {
        const checkbox = document.querySelector('.kaching-bundles__subscriptions__checkbox');
        if (!checkbox) return false;

        if (checkbox.querySelector('input[type="checkbox"]:checked')) return true;
        if (
            checkbox.classList.contains('active') ||
            checkbox.classList.contains('selected') ||
            checkbox.classList.contains('is-selected')
        ) {
            return true;
        }
        if (checkbox.querySelector('svg')) return true;

        return false;
    }

    function buildCheckoutChampUrl(cart, config) {
        if (!config || !cart?.items?.length) return null;

        let activeIdMap = null;
        if (config.idMap) {
            activeIdMap = config.idMap;
        } else if (config.subscriptionIdMap && config.nonSubscriptionIdMap) {
            activeIdMap = isKachingSubscriptionSelected()
                ? config.subscriptionIdMap
                : config.nonSubscriptionIdMap;
        }

        if (!activeIdMap) return null;

        const ccProducts = cart.items
            .filter((item) => activeIdMap[String(item.variant_id)])
            .map((item) => `${activeIdMap[String(item.variant_id)]}:${item.quantity}`);

        if (!ccProducts.length) return null;

        return `https://checkout.sofyre.com/checkout?products=${ccProducts.join(';')}`;
    }

    async function redirectAfterCheckoutPopup() {
        const config = window.__sofyreCheckoutChampConfig;
        if (!config) {
            window.location.href = '/checkout';
            return;
        }

        try {
            const cartRes = await fetch('/cart.js', {
                credentials: 'same-origin',
                cache: 'no-store',
            });
            if (!cartRes.ok) throw new Error('Cart fetch failed');

            const cart = await cartRes.json();
            const ccUrl = buildCheckoutChampUrl(cart, config);
            window.location.href = ccUrl || '/checkout';
        } catch (error) {
            console.error('CheckoutChamp redirect failed:', error);
            window.location.href = '/checkout';
        }
    }

    function initCheckoutUpsellPopupHandlers() {
        document.addEventListener(
            'click',
            async (event) => {
                const upsellPopup = document.getElementById('upsell-popup');
                if (!upsellPopup) return;

                const popupVisible =
                    upsellPopup.style.display !== 'none' &&
                    upsellPopup.style.display !== '' &&
                    window.getComputedStyle(upsellPopup).display !== 'none';
                if (!popupVisible) return;

                const wantBtn = event.target.closest('#upsell-popup .upsell-atc-want-btn');
                const dontBtn = event.target.closest('#upsell-popup .upsell-atc-dont-want-btn');
                const closeBtn = event.target.closest(
                    '#upsell-popup .upsell-close-icon, #upsell-popup .upsell-close-icon svg, #upsell-popup #cross'
                );

                if (!wantBtn && !dontBtn && !closeBtn) return;

                event.preventDefault();
                event.stopPropagation();
                event.stopImmediatePropagation();

                if (!wantBtn) {
                    await redirectAfterCheckoutPopup();
                    return;
                }

                if (wantBtn.dataset.loading === 'true') return;

                wantBtn.dataset.loading = 'true';
                wantBtn.setAttribute('aria-busy', 'true');
                wantBtn.textContent = 'Adding...';

                try {
                    await addCheckoutPopupUpsell(wantBtn);
                } catch (error) {
                    console.error('Error adding checkout popup upsell:', error);
                }

                await redirectAfterCheckoutPopup();
            },
            true
        );
    }

    initCheckoutUpsellPopupHandlers();

    const SOFYRE_CHECKOUT_POPUP_AB_CLASS = 'sofyre-enable-checkout-popup';

    function isListicleCheckoutPopupPage() {
        return Boolean(
            document.querySelector('lp-buy-box[data-checkout-popup-eligible="true"]')
        );
    }

    function isCheckoutPopupAbEnabled() {
        if (typeof window.sofyreIsCheckoutPopupAbEnabled === 'function') {
            return window.sofyreIsCheckoutPopupAbEnabled();
        }
        return (
            document.documentElement.classList.contains(SOFYRE_CHECKOUT_POPUP_AB_CLASS) ||
            (document.body && document.body.classList.contains(SOFYRE_CHECKOUT_POPUP_AB_CLASS))
        );
    }

    function shouldShowCheckoutPopup() {
        if (isListicleCheckoutPopupPage()) {
            return isCheckoutPopupAbEnabled();
        }
        return true;
    }

    function isCritterCheckoutHandle(handle) {
        const value = String(handle || '').toLowerCase();
        return (
            value.includes('critter') ||
            value.includes('flea') ||
            value.includes('cockroach') ||
            value.includes('bed-bug') ||
            value.includes('tick')
        );
    }

    function applyCheckoutUpsellProduct(popup, product) {
        if (!popup || !product) return;

        const image = popup.querySelector('.upsell-product-image img');
        if (image && product.image) {
            image.src = product.image;
            image.alt = product.title || 'upsell-image';
        }

        const title = popup.querySelector('.upsell-product-title');
        if (title) title.textContent = product.title || '';

        const description = popup.querySelector('.upsell-product-description');
        if (description) description.innerHTML = product.description || '';

        const priceWrap = popup.querySelector('.upsell-product-price');
        if (priceWrap) {
            const compare = product.showCompare && product.comparePrice
                ? `<p class="upsell-compare-price">${product.comparePrice}</p>`
                : '';
            priceWrap.innerHTML = `${compare}<p class="upsell-sale-price">${product.price || ''}</p>`;
        }

        const wantButton = popup.querySelector('.upsell-atc-want-btn');
        if (wantButton) {
            wantButton.setAttribute('data-product-id', String(product.id || ''));
            wantButton.setAttribute('data-selling-id', String(product.sellingPlanId || ''));
            delete wantButton.dataset.loading;
            wantButton.removeAttribute('aria-busy');
        }
    }

    window.SofyreCheckoutUpsell = {
        async openFromCart() {
            const popup = document.getElementById('upsell-popup');
            if (!popup) return false;

            if (!shouldShowCheckoutPopup()) {
                return false;
            }

            let useCritter = false;
            try {
                const cartRes = await fetch('/cart.js', {
                    credentials: 'same-origin',
                    cache: 'no-store',
                });
                if (cartRes.ok) {
                    const cart = await cartRes.json();
                    useCritter = (cart.items || []).some((item) => isCritterCheckoutHandle(item.handle));
                }
            } catch (error) {
                console.warn('Checkout popup cart check failed:', error);
            }

            const catalogEl = document.getElementById('sofyre-checkout-upsell-products');
            if (catalogEl) {
                try {
                    const catalog = JSON.parse(catalogEl.textContent);
                    let product = catalog.rodent;
                    if (useCritter) {
                        if (catalog.critter) {
                            product = catalog.critter;
                        } else {
                            console.warn(
                                'Checkout popup: critter cart but critter upsell missing from catalog (critter-control-spray-4).'
                            );
                            return false;
                        }
                    }
                    applyCheckoutUpsellProduct(popup, product);
                } catch (error) {
                    console.warn('Checkout popup catalog failed:', error);
                }
            }

            document.body.appendChild(popup);
            popup.style.zIndex = '100000';
            popup.style.display = 'flex';
            document.body.classList.add('overflow-hidden');
            return true;
        },
    };

    // --- Element Variables ---
    const checkoutButton = document.querySelector(CHECKOUT_BTN_SELECTOR);
    const popup = document.getElementById('conversion-popup');
    const productList = document.getElementById('one-time-product-list');
    const noThanksButton = document.getElementById('no-thanks-button'); // Renamed to keep its function

    if (!checkoutButton || !popup) {
        console.warn('Conversion logic not fully initialized: Checkout button or popup missing.');
        return;
    }

    // --- Core Functions ---

    const proceedToCheckout = () => {
        popup.style.display = 'none';
        //window.location.href = '/checkout';
    };

    /**
     * Collects all one-time line items from the cart drawer, reading dynamic data.
     * (Same as previous step - reads data-item-key, data-variant-id, etc.)
     */
    const collectOneTimeItems = () => {
        const items = document.querySelectorAll('[data-item-type="one-time"]');
        
        return Array.from(items).map(el => {
            const itemKey = el.getAttribute('data-item-key');
            const productId = el.getAttribute('data-product-id');
            const variantId = el.getAttribute('data-variant-id');
            const sellingPlanId = el.getAttribute('data-subscription-plan-id'); 
            const productImg = el.querySelector('.cart-item__image').getAttribute('src'); 
            const price = el.querySelector('.cart-item__price-wrapper .regular-price').innerText;
            const quantityElement = el.querySelector('.cart-item__quantity-input') || el.querySelector('.cart-item__quantity');
            const quantity = quantityElement ? quantityElement.querySelector('.quantity__input').value : 1;
            if (!sellingPlanId || sellingPlanId.trim() === '') {
                return null; 
            }
            
            return {
                key: itemKey,
                product_image: productImg,
                variantId: variantId,
                productId:productId,
                name: el.querySelector('.cart-item__name')?.textContent || 'One-Time Product',
                quantity: quantity,
                // regular_price: regular_price,
                compare_price:price,
                sellingPlanId: sellingPlanId
            };
        }).filter(item => item !== null);
    };

    /**
     * Builds the list with a separate "Convert" button for each item.
     */
    const buildProductList = (items) => {
        productList.innerHTML = '';
        items.forEach(item => {
            let formattedAmount = 0; // define once
            let compare_price = item.compare_price;
            let regular_price = "";
            if(item.productId == "11721539486014") {
                if(item.quantity == 3) {
                    regular_price = 59;
                } else if(item.quantity == 2) {
                    regular_price = 49;
                } else if(item.quantity == 1) {
                    regular_price = 25;
                }
                if(regular_price === "" || regular_price === undefined){
                    compare_price = "";
                }
                if (window?.Shopify?.currency?.rate && regular_price) {
                    const rate = Shopify.currency.rate;
                    const currency = Shopify.currency.active;

                    const discountInLocal = regular_price * rate;

                    formattedAmount = new Intl.NumberFormat(undefined, {
                        style: 'currency',
                        currency: currency
                    }).format(discountInLocal);
                }
            } else {
                formattedAmount = compare_price;
                compare_price = "";
            }
            const li = document.createElement('li');
            li.className = 'conversion-item';
            li.setAttribute('data-item-key', item.key); // Add item key to LI for easy reference
            li.innerHTML = `
            <div class="subscription-product-info">
                <div class="subscription-product-image">
                    <img src="${item.product_image}">
                </div>
                <div class="subscription-product-detail">
                    <span class="product-name">${item.name}</span> 
                    <dl>
                    <span class="popup-price popup-regular-price">${formattedAmount}</span>
                    <span class="popup-price popup-compare-price">${compare_price}</span>
                    </dl>
                    <button 
                        class="convert-single-item-btn button button--small button--primary" 
                        data-item-key="${item.key}"
                        data-item-variant="${item.variantId}"
                    >
                        Claim Offer
                    </button>
                </div>
            </div>
            `;
            productList.appendChild(li);
        });
        
        // Attach event listener to the newly created buttons
        productList.querySelectorAll('.convert-single-item-btn').forEach(button => {
            button.addEventListener('click', handleSingleConversion);
        });
    };

    /**
     * Handles the conversion process for a single item via Cart API.
     */
    async function handleSingleConversion(event) {
        const button = event.currentTarget;
        const itemKey = button.getAttribute('data-item-key');
        const itemVariant = button.getAttribute('data-item-variant');
        
        // Find the item details from the list of one-time items
        const itemToConvert = collectOneTimeItems().find(item => item.key === itemKey);
        
        // if (!itemToConvert) {
        //     alert('Error: Could not find item details for conversion.');
        //     return;
        // }

        button.disabled = true;
        button.textContent = 'Converting...';

        await new Promise((resolve, reject) => {
            fetch('/cart/change.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json',
                },
                credentials: 'same-origin',
                body: JSON.stringify({
                    id: itemKey,
                    quantity: 0,
                }),
            })
            .then(res => {
                if (!res.ok) {
                    return res.text().then(text => {
                        throw new Error(text || '400 Bad Request');
                    });
                }
                return res.json();
            })
            .then(resolve)
            .catch(err => reject(err));
        });
        
        // 2. Prepare data for the second API call (Add subscription item)
        const additionsPayload = {
            id: itemVariant,
            quantity: itemToConvert.quantity,
            selling_plan: itemToConvert.sellingPlanId
        };
        await new Promise((resolve, reject) => {
            fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                body: new URLSearchParams(additionsPayload)
            })
            .then(res => {
                if (!res.ok) {
                    return res.text().then(text => {
                        throw new Error(text || '400 Bad Request');
                    });
                }
                return res.json();
            })
            .then(resolve)
            .catch(err => reject(err));
        });
        if(itemToConvert.quantity == 3) {
            var checkout_url = '/checkout?discount=30%25%20OFF%21';
        } else if(itemToConvert.quantity == 2) {
            var checkout_url = '/checkout?discount=30%25%20OFF%21';
        } else if(itemToConvert.quantity == 1) {
            var checkout_url = '/checkout?discount=30%25%20OFF%21';
        } else {
            var checkout_url = '/checkout';
        }
        button.textContent = 'Converted';
            if(document.querySelectorAll('.conversion-item').length > 1) {
                document.getElementById('no-thanks-button').setAttribute('href',checkout_url);
                document.getElementById('re-direct-checkout').style.display = 'block';
            } else {
                window.location.href= checkout_url;
                document.getElementById('re-direct-checkout').style.display = 'none';
            }

        // async function updateCartIndicators() {
        //     try {
        //         const response = await fetch('/cart.js');
        //         const cart = await response.json();
        //         const totalItems = cart.item_count;
                
        //         // 1. Update the cart count number wherever it is displayed
        //         document.querySelector('.cart-count-bubble span[aria-hidden="true"]').textContent = totalItems;
        //         const cartIcon = document.querySelector('.header__icon--cart'); 
        //         if (cartIcon) {
        //             // Dispatch a click event to force the drawer to reopen/refresh
        //             cartIcon.dispatchEvent(new Event('click'));
        //             popup.style.display = 'none';
        //         }
        //         fetch(`${routes.cart_url}?section_id=cart-drawer`)
        //             .then((response) => response.text())
        //             .then((responseText) => {
        //             const html = new DOMParser().parseFromString(
        //                 responseText,
        //                 "text/html"
        //             );
        //             const selectors = [".cart-progress","cart-drawer-items", ".cart-drawer__footer"];
        //             for (const selector of selectors) {
        //                 const targetElement = document.querySelector(selector);
        //                 const sourceElement = html.querySelector(selector);
        //                 if (targetElement && sourceElement) {
        //                 targetElement.replaceWith(sourceElement);
        //                 }
        //             }
        //             $('cart-remove-button').addClass('custom--removed-product');
        //         });
                
        //     } catch (error) {
        //         console.error("Failed to fetch cart data:", error);
        //     }
        // }
        //  updateCartIndicators();
    }

    async function prepareCartForCheckout() {
        if (window.SofyreCartUpsells?.syncCartState) {
            await window.SofyreCartUpsells.syncCartState();
        }
    }

    async function handleCheckoutLogic() {
        await prepareCartForCheckout();

        // 2. Get all line items and determine the overall cart state
        const cartItems = document.querySelectorAll('.cart-drawer-item');
        let hasSubscription = false;
        let hasOneTime = false;

        cartItems.forEach(item => {
            const productType = item.getAttribute('data-item-type');
            if (productType === 'subscription') {
                hasSubscription = true;
            } else if (productType === 'one-time') {
                hasOneTime = true;
            }
        });

        if (!shouldShowCheckoutPopup()) {
            void redirectAfterCheckoutPopup();
            return;
        }

        // 3. Apply the custom rules
        if (hasOneTime && !hasSubscription) {
            // this (triggerSubscriptionPopup) function use for subscription popup 
            // triggerSubscriptionPopup();
            setTimeout(() => {
                void triggerUpsellPopup();
            }, 2000);
        } else if (hasSubscription) {
            // alert('--- upsell ---');
            setTimeout(() => {
                void triggerUpsellPopup();
            }, 2000);
        } else {
            // alert('--- checkout ---');
            proceedToCheckout();
        }
    }
    
    // --- Popup Functions (You need to define these and your HTML modal) ---
    function triggerSubscriptionPopup() {
        // alert('--- SHOW subscription POPUP ---');
        const oneTimeItems = collectOneTimeItems();
        if (oneTimeItems.length > 0) {
            buildProductList(oneTimeItems); // Build the list with individual buttons
            popup.style.display = 'flex'; // Show the modal
            const cartDrawer = document.querySelector('cart-drawer') || document.getElementById('CartDrawer');
            if (cartDrawer && typeof cartDrawer.close === 'function') {
                cartDrawer.close(); 
            }
        } else {
            proceedToCheckout();
        }
    }

    async function triggerUpsellPopup() {
        const upsell_popup = document.getElementById('upsell-popup');
        if (!upsell_popup) return;

        if (window.SofyreCheckoutUpsell?.openFromCart) {
            const opened = await window.SofyreCheckoutUpsell.openFromCart();
            if (opened) {
                const cartDrawer =
                    document.querySelector('cart-drawer') || document.getElementById('CartDrawer');
                if (cartDrawer && typeof cartDrawer.close === 'function') {
                    cartDrawer.close();
                }
            }
            return;
        }

        upsell_popup.style.display = 'flex';
    }

    // --- MAIN EVENT LISTENER: Checkout Click ---
    document.body.addEventListener('click', (event) => {
        const checkoutButton = event.target.closest(CHECKOUT_BTN_SELECTOR);

        if (checkoutButton) {
            event.preventDefault();
            handleCheckoutLogic();
        }
    });
});

// --- BFCACHE RESET: navigating Back from checkout must not restore an open
// drawer/upsell. A pageshow-only reset still flashes: the restored frame
// paints before pageshow handlers run, and removing .active replays the
// drawer's visibility/transform transitions as a visible slide-out. So the
// DOM is cleaned in pagehide — mutations there persist into the bfcache
// entry, and the page restores already closed. Transitions are disabled
// inline through the freeze/restore so any residual pageshow cleanup paints
// instantly; they're re-enabled two frames after restore.
(() => {
    const drawerTransitionEls = (drawer) => {
        const els = [drawer];
        const inner = drawer.querySelector('.drawer__inner');
        if (inner) els.push(inner);
        return els;
    };

    const resetCartOverlays = () => {
        document.querySelectorAll('cart-drawer, #CartDrawer').forEach((drawer) => {
            drawerTransitionEls(drawer).forEach((el) => {
                el.style.transition = 'none';
            });
            drawer.classList.remove('active', 'animate');
            drawer.removeAttribute('open');
            if (typeof drawer.close === 'function') {
                drawer.close();
            }
        });

        const upsellPopup = document.getElementById('upsell-popup');
        if (upsellPopup) {
            upsellPopup.style.display = 'none';
        }

        document.body.classList.remove('overflow-hidden');
    };

    window.addEventListener('pagehide', resetCartOverlays);

    window.addEventListener('pageshow', (event) => {
        if (event.persisted) {
            resetCartOverlays();
        }
        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                document.querySelectorAll('cart-drawer, #CartDrawer').forEach((drawer) => {
                    drawerTransitionEls(drawer).forEach((el) => {
                        el.style.transition = '';
                    });
                });
            });
        });
    });
})();
